import { PropType, defineComponent } from 'vue';

import { NumberInputEnum } from '@/bundles/Common/types/numberInput';
import { Nullable } from '@/utils/types';

const NumberInputMixin = defineComponent({
  props: {
    modelValue: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: null
    },
    hideDetails: {
      type: [Boolean, String],
      default: true
    },
  },

  data: (): { NumberInputEnum: typeof NumberInputEnum } => ({
    NumberInputEnum
  }),
})

export { NumberInputMixin };
